/** Convierte #RRGGBB a canales HSL para variables CSS (formato Tailwind: "H S% L%"). */
export function hexToHslChannels(hex) {
  let h = String(hex || '#C62828').trim();
  if (!h.startsWith('#')) h = `#${h}`;
  if (h.length === 4) {
    h = `#${h[1]}${h[1]}${h[2]}${h[2]}${h[3]}${h[3]}`;
  }
  const r = parseInt(h.slice(1, 3), 16) / 255;
  const g = parseInt(h.slice(3, 5), 16) / 255;
  const b = parseInt(h.slice(5, 7), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let hue = 0;
  let sat = 0;
  const light = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    sat = light > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        hue = ((g - b) / d + (g < b ? 6 : 0)) / 6;
        break;
      case g:
        hue = ((b - r) / d + 2) / 6;
        break;
      default:
        hue = ((r - g) / d + 4) / 6;
        break;
    }
  }
  return `${Math.round(hue * 360)} ${Math.round(sat * 100)}% ${Math.round(light * 100)}%`;
}

export function applyThemeFromClinicInfo(info) {
  if (!info || typeof document === 'undefined') return;
  const root = document.documentElement;
  const primary = hexToHslChannels(info.theme_primary_hex || '#C62828');
  const bg = hexToHslChannels(info.theme_background_hex || '#FFF5F5');
  const fg = hexToHslChannels(info.theme_foreground_hex || '#2D0A0A');
  const accent = hexToHslChannels(info.theme_accent_hex || '#FF6B6B');
  const muted = hexToHslChannels(info.theme_muted_hex || '#FFD4D4');

  root.style.setProperty('--primary', primary);
  root.style.setProperty('--foreground', fg);
  root.style.setProperty('--background', bg);
  root.style.setProperty('--accent', accent);
  root.style.setProperty('--secondary', muted);
  root.style.setProperty('--muted', muted);
  root.style.setProperty('--card', '0 0% 100%');
  root.style.setProperty('--card-foreground', fg);
  root.style.setProperty('--popover', '0 0% 100%');
  root.style.setProperty('--popover-foreground', fg);
  root.style.setProperty('--primary-foreground', '0 0% 100%');
  root.style.setProperty('--secondary-foreground', fg);
  root.style.setProperty('--muted-foreground', fg);
  root.style.setProperty('--accent-foreground', '0 0% 100%');
  root.style.setProperty('--border', muted);
  root.style.setProperty('--input', muted);
  root.style.setProperty('--ring', primary);

  root.dataset.checkerboard = info.theme_show_checkerboard ? '1' : '0';
}
